var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.8 3A2.2 2.2 0 013 .8h10A2.2 2.2 0 0115.2 3v10a2.2 2.2 0 01-2.2 2.2H3A2.2 2.2 0 01.8 13V3zM3 2a1 1 0 00-1 1v10a1 1 0 001 1h10a1 1 0 001-1V3a1 1 0 00-1-1H3zm5 2a.6.6 0 01.6.6v6.8a.6.6 0 11-1.2 0V4.6A.6.6 0 018 4zM5.4 6.4A.6.6 0 016 7v4.4a.6.6 0 11-1.2 0V7a.6.6 0 01.6-.6zM10.6 8a.6.6 0 01.6.6v2.8a.6.6 0 11-1.2 0V8.6a.6.6 0 01.6-.6z",
    fill: "#272E35"
  })));
}
export default SvgChart;